module.exports = __webpack_public_path__ + "static/media/img_top_main1.2cca8952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_top_main1.jpg
// module id = 767
// module chunks = 0